<template>
  <input
    id="ny_vejkode"
    maxlength="4"
    pattern="\d*"
    placeholder="(Ingen)"
    v-on:keyup="validateInput"
    :value="this.vejkode"
  />
</template>

<script>
export default {
  name: 'VejkodeNumberInput',
  props: {
    onChange: Function,
    vejkode: Number,
  },
  methods: {
    validateInput (e) {
      const { key, keyCode } = e;
      if (keyCode === 8 || !isNaN(key)) {
        this.onChange(e.target.value);
      } else {
        e.target.value = e.target.value.replace(key, '');
      }
    },
  },
  mounted () {
    if (this.vejkode) {
      this.onChange(this.vejkode.toString());
    }
  },
};
</script>

<style lang="scss" scoped>
#ny_vejkode {
  font-size: 48px;
  font-weight: 600;
  width:140px;
  height: 80px;
  text-align: center;
  border: none;
  background: rgba(255,255,255, 0.5);
  color: rgb(131, 68, 163);
  align-self: stretch;
}
#ny_vejkode::placeholder {
  color: $default-color-light;
  font-size: 32px;
}
#ny_vejkode:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: $default-color-light;
  font-size: 32px;
}
#ny_vejkode::-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: $default-color-light;
  font-size: 32px;
}
#ny_vejkode::-webkit-input-placeholder { /* chrome */
  color: $default-color-light;
  font-size: 32px;
}
</style>
